import React, { Component } from 'react';
import VerifyEmailPhone from '../../client/components/verifyEmailPhone';
import Header from '../../client/shared-ui/header/index';
import { breakPoint_L } from '../../utility/breakPoints';

class VerifyEmailPhonePage extends Component {
  render () {
    let Headers;
    if(breakPoint_L==false) {
      Headers=<Header />;
    }
    return (
      <>
        { Headers }
        <VerifyEmailPhone />
      </>
    );
  }
}

export default VerifyEmailPhonePage;